var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-loader"},[(_vm.status === 'loaded')?_vm._t("image"):(_vm.status === 'failed')?_vm._t("error"):(_vm.status === 'loading')?_vm._t("preloader"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }